import styled from 'styled-components';

export const Container = styled.div`
  background-color: #F4F4F5;
  padding: 15px 15px 25px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`;

export const Title = styled.span`
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: #323131;
`;

export const ListContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 22px;

  &:before {
    content: '';
    position: absolute;
    left: -18px;
    top: 4px;
    width: 8px;
    height: 8px;
    background-color: #C18244;
    border-radius: 50%;
  }

  font-size: 14px;
  line-height: 1.2;
  font-weight: 400;
  color: #323131;
`;
